import React, { useContext } from 'react'
import { date, month, year } from '../../../../constants/dateConstants'
import DateSelector from './DateSelector'

const DateBirthV1 = ({ formik, contextValue, disabled = false }) => {
  const { regFields } = useContext(contextValue)
  const { values, setFieldValue, setFieldTouched } = formik
  const parseDateParts = () => {
    const raw = values?.dateOfBirth
    if (!raw) {
      return { year: 'YYYY', month: 'MM', day: 'DD' }
    }

    // If it's already a Date object
    if (raw instanceof Date && !isNaN(raw.getTime())) {
      return {
        year: String(raw.getFullYear()),
        month: String(raw.getMonth() + 1).padStart(2, '0'),
        day: String(raw.getDate()).padStart(2, '0')
      }
    }

    const str = String(raw).trim()
    // Try splitting by slash or dash
    let parts = []
    if (str.includes('/')) parts = str.split('/')
    else if (str.includes('-')) parts = str.split('-')
    else {
      // try parseable date
      const d = new Date(str)
      if (!isNaN(d.getTime())) {
        return {
          year: String(d.getFullYear()),
          month: String(d.getMonth() + 1).padStart(2, '0'),
          day: String(d.getDate()).padStart(2, '0')
        }
      } else {
        return { year: 'YYYY', month: 'MM', day: 'DD' }
      }
    }

    // Normalize parts -> determine which part is year
    // Remove time suffix if present on day part
    parts = parts.map(p => (p || '').split('T')[0].replace(/\D+$/g, ''))

    let year = 'YYYY'
    let month = 'MM'
    let day = 'DD'
    if (parts.length >= 3) {
      // If first part looks like year (4 digits)
      if (/^\d{4}$/.test(parts[0])) {
        year = parts[0]
        month = parts[1] || 'MM'
        day = parts[2] || 'DD'
      } else if (/^\d{4}$/.test(parts[2])) {
        // maybe DD-MM-YYYY
        year = parts[2]
        month = parts[1] || 'MM'
        day = parts[0] || 'DD'
      } else {
        year = parts[0] || 'YYYY'
        month = parts[1] || 'MM'
        day = parts[2] || 'DD'
      }
    } else {
      // Fallback parsing via Date
      const d = new Date(str)
      if (!isNaN(d.getTime())) {
        year = String(d.getFullYear())
        month = String(d.getMonth() + 1).padStart(2, '0')
        day = String(d.getDate()).padStart(2, '0')
      }
    }

    // ensure padding for day/month
    month = month !== 'MM' ? String(Number(month)).padStart(2, '0') : 'MM'
    day = day !== 'DD' ? String(Number(day)).padStart(2, '0') : 'DD'

    return { year, month, day }
  }

  const getDayValue = () => {
    const { day } = parseDateParts()
    return day !== 'DD' ? String(day).padStart(2, '0') : 'DD'
  }

  const getMonthValue = () => {
    const { month } = parseDateParts()
    return month !== 'MM' ? String(month).padStart(2, '0') : 'MM'
  }

  const getYearValue = () => {
    const { year } = parseDateParts()
    return year !== 'YYYY' ? String(year) : 'YYYY'
  }

  const onChange = (value, label) => {
    const parts = parseDateParts()

    const updated = {
      year: label === 'year' ? value : parts.year,
      month: label === 'month' ? value : parts.month,
      day: label === 'date' ? value : parts.day
    }

    // keep placeholders if not selected
    const y = updated.year || 'YYYY'
    const m = updated.month !== 'MM' ? String(updated.month).padStart(2, '0') : 'MM'
    const d = updated.day !== 'DD' ? String(updated.day).padStart(2, '0') : 'DD'

    const newValue = (y === 'YYYY' && m === 'MM' && d === 'DD') ? '' : `${y}/${m}/${d}`

    setFieldValue('dateOfBirth', newValue)

    const isComplete = y !== 'YYYY' && m !== 'MM' && d !== 'DD'

    // mark touched and validate immediately when complete
    if (isComplete) {
      setFieldTouched('dateOfBirth', true, false)
      if (typeof formik.validateField === 'function') {
        formik.validateField('dateOfBirth')
      }
    }
  }

  return (
    <>
      {regFields?.dateOfBirth !== 0 && (
        <div className='date-of-birth-container'>
          <DateSelector
            label='date'
            values={values}
            onChange={onChange}
            options={['DD', ...date.map(d => String(d).padStart(2, '0'))]}
            getValue={getDayValue}
            contextValue={contextValue}
            disabled={disabled}
          />
          <DateSelector
            label='month'
            values={values}
            onChange={onChange}
            options={['MM', ...month.map(m => String(m).padStart(2, '0'))]}
            getValue={getMonthValue}
            contextValue={contextValue}
            disabled={disabled}
          />
          <DateSelector
            label='year'
            values={values}
            onChange={onChange}
            options={['YYYY', ...year.map(y => String(y))]}
            getValue={getYearValue}
            contextValue={contextValue}
            disabled={disabled}
          />
        </div>
      )}
    </>
  )
}

export default DateBirthV1
